import React from 'react';
import cn from 'classnames';
import { Button } from "../Button";
import { Typography } from "../Typography";
import styles from "./BottomSheetContentLayout.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function BottomSheetContentLayout(props) {
  var _footer$paddingGutter, _footer$paddingGutter2, _footer$primaryAction, _footer$secondaryActi;
  const {
    children,
    header,
    footer,
    contentClassName,
    contentGutter
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "data-testid": "bottom-sheet-header-slot",
      children: header && /*#__PURE__*/_jsxs("div", {
        className: styles.header,
        "data-testid": "bottom-sheet-header",
        style: {
          paddingBottom: header.paddingBottom
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          weight: "normal",
          children: header.title
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: header.subtitle
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles.content, contentClassName, {
        [styles["".concat(contentGutter, "Gutter")]]: contentGutter
      }),
      children: children
    }), /*#__PURE__*/_jsx("div", {
      "data-testid": "bottom-sheet-footer-slot",
      children: footer && /*#__PURE__*/_jsxs("div", {
        "data-testid": "bottom-sheet-footer",
        className: styles.footer,
        style: {
          paddingLeft: (_footer$paddingGutter = footer.paddingGutter) !== null && _footer$paddingGutter !== void 0 ? _footer$paddingGutter : 16,
          paddingRight: (_footer$paddingGutter2 = footer.paddingGutter) !== null && _footer$paddingGutter2 !== void 0 ? _footer$paddingGutter2 : 16,
          paddingTop: footer.paddingTop
        },
        children: [footer.primaryAction && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Button, {
            fluid: true,
            roundness: "m",
            onClick: footer.primaryAction.onClick,
            disabled: footer.primaryAction.disabled,
            testId: (_footer$primaryAction = footer.primaryAction.testId) !== null && _footer$primaryAction !== void 0 ? _footer$primaryAction : 'bottom-sheet-primary-action',
            intent: footer.primaryAction.intent,
            loading: footer.primaryAction.loading,
            tooltip: footer.primaryAction.tooltip,
            bi: footer.primaryAction.bi,
            children: footer.primaryAction.text
          })
        }), footer.secondaryAction && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Button, {
            fluid: true,
            roundness: "m",
            skin: "primaryOutline",
            onClick: footer.secondaryAction.onClick,
            disabled: footer.secondaryAction.disabled,
            testId: (_footer$secondaryActi = footer.secondaryAction.testId) !== null && _footer$secondaryActi !== void 0 ? _footer$secondaryActi : 'bottom-sheet-secondary-action',
            children: footer.secondaryAction.text
          })
        })]
      })
    })]
  });
}